import { useState } from "react";

export default function useSortData() {
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: "asc"
  });

  const defaultSortIcon = " ⇅";
  
  const sortData = (items) => {
    if (!sortConfig.key) return items;

    return [...items].sort((a, b) => {
      const valueA = a[sortConfig.key] ?? "";
      const valueB = b[sortConfig.key] ?? "";

      if (valueA < valueB) return sortConfig.direction === "asc" ? -1 : 1;
      if (valueA > valueB) return sortConfig.direction === "asc" ? 1 : -1;
      return 0;
    });
  };

  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
  };

  return { sortConfig, sortData, handleSort };
}
